import React from 'react';
import { useGetOurPickProducts } from '../../api/product';
import { useNavigate } from 'react-router-dom';
import ProductList from './ProductList';
import { useBrands } from '../../contexts/BrandContext';
import { enhanceProductsWithBrands } from '../../utils/brandUtils';
import { useTranslation } from 'react-i18next';

const OurPicks: React.FC = () => {
  const { productsData, productsIsLoading } = useGetOurPickProducts();
  const { brands } = useBrands();
  const navigate = useNavigate();

  const { t } = useTranslation();
  
  // Enhance products with brand names using cached brand data
  const enhancedProducts = React.useMemo(() => {
    if (productsData && brands.length > 0) {
      return enhanceProductsWithBrands(productsData, brands);
    }
    return productsData || [];
  }, [productsData, brands]);
  
  // Use all products for horizontal scrolling, but limit skeleton count for loading state
  const products = enhancedProducts;

  return (
    <ProductList
      products={products}
      loading={productsIsLoading}
      variant="horizontal"
      title={t('ourPicks.title')}
      onViewMore={() => navigate('/our-picks')}
    />
  );
};

export default OurPicks;
